export class Item {
    title: string
    subTitle: string

    constructor(title: string, subTitle?: string) {
        this.title = title;
        this.subTitle = subTitle;
    }
}

export const TEMPLATE = {
    SPECIAL_BUDGET: 'special_budget',
    SPECIAL_BUDGET_SOME_DAYS: 'special_budget_some_days',
    SPECIAL_BUDGET_POI: 'special_budget_poi',
    NORMAL_BUDGET: 'normal_budget',
    UNLIMITED_BUDGET: 'unlimited_budget',
    UNLIMITED_SHARE_BUDGET_FEATURE: 'unlimited_share_budget_feature',
    SHARE_BUDGET: 'share_budget',
    SHARE_BUDGET_SPECIAL_BUDGET: 'share_budget_special_budget',
    SHARE_BUDGET_SPECIAL_BUDGET_POI: 'share_budget_special_budget_poi',
}

export const BUDGET_TYPE = {
    NEW_BUDGET: 'new_budget',
    NORMAL_BUDGET: 'normal_budget'
}

export const TOTAL_BUDGET_TYPE = {
    NORMAL_BUDGET: 'normal_budget',
    CO_BUDGET: 'co_budget',
    SPECIAL_CO_BUDGET: 'special_co_budget'
}



// WEBPACK FOOTER //
// ./src/app/components/budget-limit/budget-limit.model.ts